module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "show": _vm.showConsign,
      "show-cell": false,
      "data": _vm.List
    },
    on: {
      "on-hide": function($event) {
        _vm.showConsign = false
      }
    },
    model: {
      value: (_vm.consign),
      callback: function($$v) {
        _vm.consign = $$v
      },
      expression: "consign"
    }
  }), _vm._v(" "), _c('cell', {
    staticClass: "cell-height",
    attrs: {
      "value-align": "left",
      "is-link": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showConsign = true
      }
    }
  }, [_c('img', {
    staticClass: "cell-lable-right",
    attrs: {
      "slot": "icon",
      "width": "20",
      "src": require("../../assets/img/jjBagge.png")
    },
    slot: "icon"
  }), _vm._v(" "), _c('div', {
    staticClass: "cell-fontSize",
    attrs: {
      "slot": "value"
    },
    slot: "value"
  }, [_c('span', {
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v(_vm._s(_vm.consign[0]))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3189212"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ConsignPick.vue
// module id = 416
// module chunks = 1